const phoneBeautify = (contact) => {
    return contact.toString().replace(/\d(?=(?:\d{3})+$)/g, '$& ');
}

export default phoneBeautify;